import { Spinner } from "@/components/Spinner";

type VideoPreviewProps = {
	videoSrc: string | null;
	mime?: string;
	loading: boolean;
	onClose: () => void;
};

export const VideoPreview = ({ videoSrc, mime, loading, onClose }: VideoPreviewProps) => (
	<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 cursor-pointer" onClick={onClose}>
		{loading || !videoSrc ? (
			<Spinner messages={[]} size={48} />
		) : (
			<video
				controls
				autoPlay
				preload="metadata"
				playsInline
				className="max-w-[90vw] max-h-[90vh] rounded-lg"
				onClick={e => e.stopPropagation()}
			>
				<source src={videoSrc} type={mime || "video/mp4"} />
			</video>
		)}
	</div>
);
